module.exports = __webpack_public_path__ + "static/media/10d.847f6fee.png";